export default __webpack_public_path__ + "static/media/pink_pawn.518dad6c.png";